export class TradingEventBus {
    listeners = new Map();
    /** Hook báo lỗi listener. Mặc định `undefined` ⇒ im lặng, giữ nguyên hành vi cũ. */
    listenerError;
    /**
     * F-TRADE-01 (điểm C): trước đây `emit` là `forEach((fn) => fn(...))` — **không**
     * try/catch. Một listener ném lỗi làm các listener còn lại của cùng event **không
     * chạy**, và lỗi nổi lên `VirtualBrokerEngine.emitAll()` (:426) rồi lên `onBar`.
     * `emitAll` phát 4 event theo thứ tự, nên người dùng có thể thấy "lệnh đã đặt" mà
     * vị thế không bao giờ được cập nhật.
     *
     * Sửa: bọc từng listener, giữ nguyên thứ tự, gom lỗi qua `onListenerError` nếu có.
     */
    onListenerError(hook) {
        this.listenerError = hook;
    }
    on(event, callback) {
        let set = this.listeners.get(event);
        if (!set) {
            set = new Set();
            this.listeners.set(event, set);
        }
        const fn = callback;
        set.add(fn);
        return () => {
            set?.delete(fn);
        };
    }
    emit(event, payload) {
        const set = this.listeners.get(event);
        if (!set)
            return;
        for (const fn of [...set]) {
            try {
                fn(payload);
            }
            catch (error) {
                this.listenerError?.(event, error);
            }
        }
    }
}
